import { USER_PREFERENCES_KEY } from './user-preferences.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserPreferencesState } from './user-preferences.models';

export const userPreferencesSelector = createFeatureSelector<UserPreferencesState>(USER_PREFERENCES_KEY);

// eslint-disable-next-line
export const getLanguage = () =>
  createSelector(userPreferencesSelector, (state: UserPreferencesState) => state.language);
// eslint-disable-next-line
export const getTimeZone = () =>
  createSelector(userPreferencesSelector, (state: UserPreferencesState) => state.timeZone);
// eslint-disable-next-line
export const getCurrency = () =>
  createSelector(userPreferencesSelector, (state: UserPreferencesState) => state.currency);
// eslint-disable-next-line
export const getPartNumberDisplay = () =>
  createSelector(userPreferencesSelector, (state: UserPreferencesState) => state.partNumberDisplay);
// eslint-disable-next-line
export const getPackDescriptionDisplay = () =>
  createSelector(userPreferencesSelector, (state: UserPreferencesState) => state.packDescriptionDisplay);
// eslint-disable-next-line
export const getShowInternalNotes = () =>
  createSelector(userPreferencesSelector, (state: UserPreferencesState) => state.showInternalNotes);
// eslint-disable-next-line
export const getShowSpecialInstructions = () =>
  createSelector(userPreferencesSelector, (state: UserPreferencesState) => state.showSpecialInstructions);
// eslint-disable-next-line
export const getReceiveEmailNotifications = () =>
  createSelector(userPreferencesSelector, (state: UserPreferencesState) => state.receiveEmailNotifications);
// eslint-disable-next-line
export const getAllUserPreferences = () =>
  createSelector(userPreferencesSelector, (state: UserPreferencesState) => state);
// eslint-disable-next-line
export const getPlant = () => createSelector(userPreferencesSelector, (state: UserPreferencesState) => state.plant);
